import { useEffect, useMemo, useReducer, useRef, useState } from 'react'
import styles from './index.less'
import classNames from 'classnames'
import ReactDOM from 'react-dom/client'
import closeSvg from '@/assets/icon/close.svg'
import {  setIsLogin, useStore } from '@/states/store'

export const TipDialog = ({ open, onClose }: any) => {
  const [isShow, setIsShow] = useState(false)
  const baseStore = useStore()

  useEffect(() => {
    if (open) {
      setIsShow(true)
      setTimeout(() => {
        clickClose()
      },5000)
    }
  }, [open])

  useEffect(() => {
    if (isShow) {
      //   RprmUtils.rec(`show_newUser_login_dialog`, 'view', { en: 'tap', et: 'custom' })
    }
  }, [isShow])

  const clickClose = () => {
    const url = new URL(window.location.href)
    url?.searchParams?.delete('showTips') // 删除指定参数
    window.history?.replaceState({}, '', url);
    setIsShow(false)
    onClose && onClose()
  }

  return (
    isShow && (
      <div className={classNames(styles.mask, styles.openDialog)}>
        <div className={styles.container}>
          <div className={styles.close} onClick={clickClose}>
            <img src={closeSvg} />
          </div>
          <div className={styles.title}>店铺已刷新</div>
          <div className={styles.subTitle}>一次仅支持一个店铺在线，已刷新为如下店铺</div>
          <div className={styles.swithcContent}>
            <div className={styles.bositem} >
              <div className={styles.logo}>
                <img src={baseStore.bosInfo.logo} alt="" />
              </div>
              <div className={styles.bosName}>{baseStore.bosInfo?.bosName}</div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export const openTipDialog = (params: {
  onClose?: Function // 取消回调
}) => {
  const { onClose, ...rest } = params
  const dom = document.getElementById('TipDialogWrapper')
  dom && dom.parentElement && dom.parentElement.removeChild(dom)
  const container = document.createElement('div')
  // const id = new Date().getTime() + 'exportDialog';
  const id = 'TipDialogWrapper'
  container.setAttribute('id', id)
  document.body.appendChild(container)
  const root = ReactDOM.createRoot(container)

  const cancel = () => {
    root.unmount()
    container && container.parentElement && container.parentElement.removeChild(container)
  }
  window.addEventListener('popstate', function (event) {
    cancel()
  })

  return root.render(
    <TipDialog
      open={true}
      onClose={e => {
        cancel()
        onClose && onClose(e)
      }}
      {...rest}
    />,
  )
}
